// extracted by mini-css-extract-plugin
export default {"root":"CookieMessage_root__PKDvU","content":"CookieMessage_content__4stiM","close":"CookieMessage_close__2klp0"};